
<ui-section >
  <ui-block width="4x">
    <ui-panel panelTitle="Draft Playground" [panelHeaderConfig]="panelHeaderConfig" (buttonClick)="onPanelHeaderButtonClick($event)">
      <ui-form
        name="draft-demo"
        [config]="sampleConfig"
        [formValues]="formValues"
        [draftConfig]="draftConfig"
        [useAutoSave]="true"
        [saveEndpoint]="saveEndpoint"
        (formUpdated)="onFormUpdated($event)"
        (formStatusUpdated)="onFormStatusChanged($event)">
      </ui-form>
    </ui-panel>

    <ui-panel panelTitle="Form Status">
      <ui-section class="status">
        <dl>
          <dt>Form Valid</dt>
          <dd>{{ formValid() ? 'Yes' : 'No' }}</dd>
          <dt>Last Autosave Payload</dt>
          <dd><pre>{{ lastAutosavePayload() | json }}</pre></dd>
        </dl>
      </ui-section>
    </ui-panel>
  </ui-block>

  <ui-block width="fill">
    <ui-panel panelTitle="Draft Event Log">
      <ui-section class="events">
        <div *ngIf="draftEvents().length === 0" class="no-events">
          No draft activity yet &mdash; start typing in the form to generate events.
        </div>
        <table *ngIf="draftEvents().length > 0">
          <thead>
            <tr>
              <th>When</th>
              <th>Action</th>
              <th>Notes & Payload</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let event of draftEvents()">
              <td>{{ event.timestamp | date:'mediumTime' }}</td>
              <td>{{ event.type | titlecase }}</td>
              <td>
                <div>{{ event.note }}</div>
                <pre *ngIf="event.payload">{{ event.payload | json }}</pre>
              </td>
            </tr>
          </tbody>
        </table>
      </ui-section>
    </ui-panel>
  </ui-block>
</ui-section>
